var exports = {
  "Yf": "activate__QmzPj7",
  "vo": "copilot__qvG-9o",
  "_7": "sparkles__uaK2pD",
  "dQ": "sparkle__c1kosT",
  "fU": "sparkleTrail__vjEHOn",
};

module.exports = exports;
